import { ManuscriptProcessingReportWithId } from "integrations/firebase/collections/manuscriptProcessingReporting";

// The card and the sheet have to title the same manuscript identically.
export const reportFileName = ({
  fileName,
  isbn,
  id,
}: ManuscriptProcessingReportWithId) => fileName ?? isbn ?? id;
